import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6v0qhuk6mq: FaireBrandEntity = {
  token: "b_6v0qhuk6mq",
  type: "brand",
  name: "Fly By Jing",
  avatarUrl:
    "https://cdn.faire.com/fastly/2fb9d197ce29445a09a4cc3851478e2f74d643764484c0d3802d6cb661eddaf4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/00fd01ebe83eb715ac54e800c8e2167ae5729e0f04dbe66600632ddbdbf1e516.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2fb9d197ce29445a09a4cc3851478e2f74d643764484c0d3802d6cb661eddaf4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/00fd01ebe83eb715ac54e800c8e2167ae5729e0f04dbe66600632ddbdbf1e516.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 97,
  isTopShop: true,
  isInsider: true,
  description:
    "Fly By Jing doesn’t do neutral. We do loud, delicious, and unforgettable—a full-on flavor arsenal of noodles, sides, and sauces inspired by the soul of Sichuan. Founded by Chef Jing Gao, what began as a personal mission to make chili crisp mainstream, has expanded into a gateway for cultural change. Using only real, high-quality ingredients (nothing artificial, ever), they make boundary-pushing flavors approachable.  Your relationship with flavor will be forever changed.\n\nIgniting a new generation of premium Asian flavors, Fly By Jing has been named a winner of the 2025 People Food Awards, 2025 Better Homes & Gardens Food Awards, 2024 NOSH Best New Products, SELF Magazine’s 2025 and 2024 Pantry Awards, Inc.’s Best in Business Awards, and one of Fast Company’s most innovative food companies in 2025, among others. Fly by Jing can be found in over 11,000 retail doors—including Target, Walmart, Whole Foods Market and Costco. Follow along @flybyjing on Instagram or TikTok.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:24.579Z",
    importedBy: "entity-db-cli",
  },
};
